import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { ConnectedPageComponent } from './core/components/connected-page/connected-page.component';
import { MentionsLegalesComponent } from './core/components/mentions-legales/mentions-legales.component';
import { AuthGuardService } from './core/guards/auth.guard';
import { AppSetUpGuard } from './core/guards/cgu.guard';
import { AppSetResolver } from './core/resolvers/init-storage.resolver';

const routes: Routes = [
  { path: '', redirectTo: 'connected', pathMatch: 'full'},
  { path: 'connected', component: ConnectedPageComponent},
  { path: 'mentions-legales', component: MentionsLegalesComponent},
  { path: 'mes-gln', resolve: [AppSetResolver], canActivate: [AuthGuardService, AppSetUpGuard], loadChildren: () => import('./hub/hub.module').then(m => m.HubModule)},
  { path: 'recherche', resolve: [AppSetResolver], canActivate: [AuthGuardService, AppSetUpGuard], loadChildren: () => import('./search/search.module').then(m => m.SearchModule)},
  {path: '**' , redirectTo: 'connected', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
